import { Box, Button, Card, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import { Linker } from 'src/Components/Ui/Linker'

const GorillaPosition: React.FC = () => {
  const baseUrl = '/hard/gorilla/'
  const isMobile = useMediaQuery('(max-width:430px)')
  return (
    <Box>
      <Box data-testid={'position-selection-page'} p={2}>
        硬式 / ごりら印の野球道具 / ポジション
      </Box>
      <Box py={2}>
        <Card style={{ padding: '16px' }}>
          <Box>グラブ</Box>
          <Box display={'flex'} justifyContent={'space-around'}>
            <Grid container>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}pitcher`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      投手用
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}infielder`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      内野手用
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}outfielder`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      外野手用
                    </Button>
                  </Linker>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
        <Box m={2} />
        <Card style={{ padding: '16px' }}>
          <Box p={0}>ミット</Box>
          <Box display={'flex'} justifyContent={'space-around'}>
            <Grid container>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}catcher`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      捕手用
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}first`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      一塁手用
                    </Button>
                  </Linker>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Box>
    </Box>
  )
}

export default GorillaPosition
